import {useMemo} from "react";
import {useSelector} from "react-redux";

export default () => {

	const {org, cookieConsentToOptional} = useSelector(store => store);

	return useMemo(() => {
		return {
			cookieConsentToOptional,
			cookieConsentRequired: (!!(org.GoogleTagManagerId))
		};
	}, [cookieConsentToOptional, org]);

};
